<template>
  <span>
    {{ $t(id, data) || defaultText }}
  </span>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'i18-lang',
  props: ['id', 'data', 'defaultText']
}
</script>
